var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('pre',[_vm._v(_vm._s(_vm.shareLink))]),_c('pre',{domProps:{"innerHTML":_vm._s(_vm.snippetLoaded.content)}}),_c('button',{on:{"click":function($event){_vm.createSnippet()}}},[_vm._v("Compartilhar")])])}
var staticRenderFns = []

export { render, staticRenderFns }